const SingleLGLender = () => {
  let $component

  const self = {
    init () {
      $component = document.querySelector('.c-single-lg_lender')
      if (!$component) return
      self.initObserver()
    },
    initObserver () {
      const options = {
        root: null,
        rootMargin: '0px'
      }

      const observer = new IntersectionObserver(self.observerCallback, options)
      observer.observe(document.querySelector('.LenderDetail__cta'))
    },
    observerCallback (entries, observer) {
      entries.forEach(entry => {
        const isAbove = entry.boundingClientRect.top < entry.rootBounds.top
        if (!entry.isIntersecting && isAbove) {
          $component.classList.add('show-scroll-detail')
        } else {
          $component.classList.remove('show-scroll-detail')
        }
      })
    }
  }

  return self
}

export default SingleLGLender
